module.exports = __webpack_public_path__ + "static/img/5introduce.ba283cb7.jpg";